import { memo } from "react";
import { Div, Dropdown, useMediaQuery, useTheme } from "react-better-html";

import { useI18n } from "../../../utils/i18n";

import Section from "../../../components/structure/Section";
import SettingItem from "./SettingItem";

function AppearanceSection() {
   const theme = useTheme();
   const mediaQuery = useMediaQuery();
   const { t } = useI18n();

   return (
      <Section
         title={t((l) => l.pages.settings.sections.appearance.title)}
         description={t((l) => l.pages.settings.sections.appearance.description)}
      >
         <Div.column gap={theme.styles.space}>
            <SettingItem
               title={t((l) => l.pages.settings.sections.appearance.fields.language)}
               description={t((l) => l.pages.settings.sections.appearance.fields.languageDescription)}
               rightElement={
                  <Dropdown.language
                     width={mediaQuery.size600 ? 150 : 200}
                     backgroundColor={theme.colors.backgroundBase}
                  />
               }
            />
         </Div.column>
      </Section>
   );
}

export default memo(AppearanceSection);
